import commandReducer from "./reducers";

export default commandReducer;